module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.findindex/~/es-abstract/helpers/sign.js
// module id = 210
// module chunks = 2